import React from 'react';
import styled from 'styled-components';
import FloorboardNumber from './floorboard_number';
import FloorboardPercent from './floorboard_percent';
import ReportDuration from 'components/reporting/report/lib/report_duration';

export default function FloorboardRow({
  icon,
  newItems,
  activeItems,
  currentWait,
  sla,
  activeLabel,
  newLabel,
  waitLabel,
}) {
  return (
    <React.Fragment>
      <IconWrapper>{icon}</IconWrapper>
      <FloorboardNumber number={newItems} label={newLabel} />
      <FloorboardNumber number={activeItems} label={activeLabel} />
      <FloorboardNumber animate={false} number={<ReportDuration duration={currentWait} />} label={waitLabel} />
      <FloorboardPercent sla={sla} label="Within SLA" />
    </React.Fragment>
  );
}

const IconWrapper = styled.div`
  border-top: 1px solid ${p => p.theme.colors.gray600};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 60px;
  .iconContainer {
    height: auto;
    width: 3vw;
    fill: ${p => p.theme.colors.white};
    margin-right: 40px;
  }
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/floorboard/floorboard_row.jsx